import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {allots,allotExfields,allotExfieldsPatch,allotExfieldsTicket,allotImport,allotExport,allocateFields,numberMachine,numberMachineReset} = api

/**
 * 查找
 */
export async function findAllots(params) {
    return request({url: allots, method: 'get', data: params,})
}
/**
 * 查找
 */
export async function updateAllot(params) {
    return request({url: allots, method: 'post', data: params,})
}

/**
 * 查找自定义
 */
export async function findAllotExfields(params) {
    return request({url: allotExfields, method: 'get', data: params,})
}
/**
 * 按票查找自定义
 */
export async function findAllotExfieldsTicket(params) {
    return request({url: allotExfieldsTicket, method: 'get', data: params,})
}
/**
 * 更新自定义
 */
export async function updateAllotExfields(params) {
    return request({url: allotExfieldsPatch, method: 'patch', data: params,})
}/**
 * 更新自定义
 */
export async function importAllot(params) {
    return request({url: allotImport, method: 'post', data: params,})
}

export async function exportAllot(params) {
    return request({url: allotExport, method: 'get', data: params,})
}
/**
 * 更新自定义
 */
export async function findAllocateFields(params) {
    return request({url: allocateFields, method: 'get', data: params,})
}
/**
 * 排号机
 */
export async function findNumberMachine(params) {
    return request({url: numberMachine, method: 'get', data: params,})
}
export async function updateNumberMachine(params) {
    return request({url: numberMachine, method: 'put', data: params,})
}
export async function resetNumberMachine(params) {
    return request({url: numberMachineReset, method: 'put', data: params,})
}




// WEBPACK FOOTER //
// ./src/services/allot.js